import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SocialPage } from "@/features/social/SocialPage";

const search = z.object({
  client: z.string().optional(),
  peek: z.string().optional(),
  day: z.string().optional(),
});

export const Route = createFileRoute("/_app/social/")({
  validateSearch: search,
  component: () => <SocialPage search={Route.useSearch()} />,
});
